
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/privacy",
      function () {
        return require("private-next-pages/terms/privacy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/privacy"])
      });
    }
  